import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useState, forwardRef, useImperativeHandle } from "react";
import { Row, Col, FormGroup } from "reactstrap";
import Password from "../../../../../Basic/Password";
import Notification from "../../../../../Basic/Notification";
import { validatePasswordApi, deleteUserApi } from '../../../../api/accountSetting.api';
var DeleteUser = /*#__PURE__*/forwardRef(function (props, ref) {
  var selectedUser = props.selectedUser,
      prefix = props.prefix,
      translate = props.translate,
      getHttpRequestStatus = props.getHttpRequestStatus,
      onDataChange = props.onDataChange;
  var userName = selectedUser.userName,
      Email = selectedUser.Email;

  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      errorMessage = _useState2[0],
      setErrorMessage = _useState2[1];

  var _useState3 = useState(''),
      _useState4 = _slicedToArray(_useState3, 2),
      password = _useState4[0],
      setPassword = _useState4[1];

  var onChangePassword = function onChangePassword(e) {
    setPassword(e.target.value);
    var enableSubmit = e.target.value ? true : false;
    onDataChange && onDataChange(enableSubmit);
    setErrorMessage('');
  };

  useImperativeHandle(ref, function () {
    return {
      submit: function () {
        var _submit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          var _yield$validatePasswo, validatePassword;

          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  getHttpRequestStatus(true, false, false);
                  _context.prev = 1;
                  _context.next = 4;
                  return validatePasswordApi(password);

                case 4:
                  _yield$validatePasswo = _context.sent;
                  validatePassword = _yield$validatePasswo.data;

                  if (validatePassword) {
                    _context.next = 11;
                    break;
                  }

                  getHttpRequestStatus(false, false, false);
                  setErrorMessage(translate('SFxAccountSettingsValidatePasswordErrorMsg'));
                  _context.next = 15;
                  break;

                case 11:
                  _context.next = 13;
                  return deleteUserApi(Email);

                case 13:
                  getHttpRequestStatus(false, true, true);
                  Notification.open({
                    description: translate('SFxAccountSettingsDeleteUserSuccess', Email)
                  });

                case 15:
                  _context.next = 20;
                  break;

                case 17:
                  _context.prev = 17;
                  _context.t0 = _context["catch"](1);
                  getHttpRequestStatus(false, true, false);

                case 20:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, null, [[1, 17]]);
        }));

        function submit() {
          return _submit.apply(this, arguments);
        }

        return submit;
      }()
    };
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix, "-delete-modal")
  }, /*#__PURE__*/React.createElement("span", null, userName), /*#__PURE__*/React.createElement("p", null, translate('SFxAccountSettingsDeleteUserConfirmMsg', userName)), /*#__PURE__*/React.createElement("p", null, translate('SFxAccountSettingsDeleteUserConfirmPasswordMsg'))), /*#__PURE__*/React.createElement(Row, {
    className: "".concat(prefix, "-delete-input")
  }, /*#__PURE__*/React.createElement(Col, {
    xs: "6"
  }, /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(Password, {
    placeHolder: translate('SFxAccountSettingsUserPasswordPlaceHolder'),
    fieldName: "password",
    onChange: onChangePassword
  })), /*#__PURE__*/React.createElement("span", {
    className: "".concat(prefix, "-require-message")
  }, errorMessage))));
});
export default DeleteUser;